
import { Component, OnInit } from '@angular/core';
import { from, Observable, of, pipe } from 'rxjs';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { distinct, map, filter, tap, switchMap } from 'rxjs/operators';
import { UserService } from '../services/user.service';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit {

  request: any;
  constructor(private userService: UserService) {
  }
       
  ngOnInit(): void { 
     
  }

}
